import React from 'react';
import { Box, Typography, Grid, Chip } from '@mui/material';
import { TrendingUp, Warning, Info } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

const RecommendationsSection = ({ recommendation }) => {
  const { t } = useTranslation();

  if (!recommendation) {
    return null;
  }

  return (
    <Box>
      <Typography variant="h6" sx={{ fontWeight: 600, mb: 2, color: '#333' }}>
        {t('healthRecommendations')}
      </Typography>

      <Grid container spacing={3}>
        {/* Summary */}
        {recommendation.summary && (
          <Grid item xs={12}>
            <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1, mb: 2 }}>
              <Info sx={{ color: '#26786A', mt: 0.5 }} />
              <Box>
                <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 1, color: '#333' }}>
                  {t('summary')}
                </Typography>
                <Typography variant="body2" sx={{ color: '#666', lineHeight: 1.6 }}>
                  {recommendation.summary}
                </Typography>
              </Box>
            </Box>
          </Grid>
        )}

        {/* Glucose Impact */}
        {recommendation.glucose_impact && (
          <Grid item xs={12} md={6}>
            <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1 }}>
              <TrendingUp sx={{ color: '#FF9800', mt: 0.5 }} />
              <Box>
                <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 1, color: '#333' }}>
                  {t('glucoseImpact')}
                </Typography>
                <Typography variant="body2" sx={{ color: '#666', lineHeight: 1.6 }}>
                  {recommendation.glucose_impact}
                </Typography>
              </Box>
            </Box>
          </Grid>
        )}

        {/* Allergy Warning */}
        {recommendation.allergy_warning && (
          <Grid item xs={12} md={6}>
            <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1 }}>
              <Warning sx={{ color: '#f44336', mt: 0.5 }} />
              <Box>
                <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 1, color: '#333' }}>
                  {t('allergyWarning')}
                </Typography>
                <Typography variant="body2" sx={{ color: '#666', lineHeight: 1.6 }}>
                  {recommendation.allergy_warning}
                </Typography>
              </Box>
            </Box>
          </Grid>
        )}

        {/* Long Term Note */}
        {recommendation.long_term_note && (
          <Grid item xs={12}>
            <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1 }}>
              <Info sx={{ color: '#2196F3', mt: 0.5 }} />
              <Box>
                <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 1, color: '#333' }}>
                  {t('longTermConsiderations')}
                </Typography>
                <Typography variant="body2" sx={{ color: '#666', lineHeight: 1.6 }}>
                  {recommendation.long_term_note}
                </Typography>
              </Box>
            </Box>
          </Grid>
        )}

        {/* Alternative Suggestions */}
        {recommendation.alternative_suggestions?.length > 0 && (
          <Grid item xs={12}>
            <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 2, color: '#333' }}>
              {t('alternativeSuggestions')}
            </Typography>
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
              {recommendation.alternative_suggestions.map((suggestion, index) => (
                <Chip
                  key={index}
                  label={suggestion}
                  size="small"
                  sx={{
                    backgroundColor: '#e8f5e8',
                    color: '#26786A',
                    border: '1px solid #26786A',
                    '&:hover': {
                      backgroundColor: '#d4edda',
                    },
                  }}
                />
              ))}
            </Box>
          </Grid>
        )}
      </Grid>
    </Box>
  );
};

export default RecommendationsSection;
